import { render } from "./Co2Slider.vue?vue&type=template&id=e5c3b634&scoped=true"
import script from "./Co2Slider.vue?vue&type=script&lang=js"
export * from "./Co2Slider.vue?vue&type=script&lang=js"

import "./Co2Slider.vue?vue&type=style&index=0&id=e5c3b634&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5c3b634"]])

export default __exports__